import { ErrorBoundaryBase, type ErrorBoundaryBaseProps } from "@core/ui";

export type Props = Omit<ErrorBoundaryBaseProps, "data-testid">;

/**
 * Styled error boundary component wrapping ErrorBoundaryBase.
 * Catches JavaScript errors in child components and renders a fallback UI.
 */
export function ErrorBoundary({
  children,
  fallback,
  resetKey,
  onError,
  className,
}: Props) {
  return (
    <ErrorBoundaryBase
      fallback={fallback}
      resetKey={resetKey}
      onError={(error, errorInfo) => {
        console.error("ErrorBoundary caught:", error);
        onError?.(error, errorInfo);
      }}
      data-testid="error-boundary"
      className={className}
    >
      {children}
    </ErrorBoundaryBase>
  );
}

export default ErrorBoundary;
